import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

import React, { useState } from "react";

import styled from "styled-components";
import { Auth, App } from "./Constants";

import ResetPassword from "../components/authentication/Reset-Password";

import PrivateRoutes from "./privateRoutes";
import ProtectedRoute from "./protectedRoute";

import Authentification from "../components/authentication/index";
import Register from "../components/authentication/Register";
import Validate from "../components/authentication/Validate";

import TopMenu from "../components/common/TopMenu/TopMenu";

import ResetPasswordValidate from "../components/authentication/Reset-Password-Validate";
import LocalStorage from "../shared/localStorage";
import PageNotFound from "./pageNotFound";

const PublicRoutes = () => {
  const getLocalStorage = localStorage.getItem(LocalStorage.USER_IRELAND);
  const parseLocalStorage = JSON.parse(getLocalStorage);

  const isLoggedIn = () => {
    const getLocalStorage = localStorage.getItem(LocalStorage.USER_IRELAND);
    const parseLocalStorage = JSON.parse(getLocalStorage);
    return parseLocalStorage?.isLoggedIn;
  };

  const [loggedInInitials, setLoggedInInitials] = useState(
    parseLocalStorage?.first_name?.charAt(0)?.toUpperCase() +
      parseLocalStorage?.last_name?.charAt(0)?.toUpperCase()
  );

  const isPublicRoute = Object.values(Auth).find((element) =>
    element.includes(window.location.pathname)
  );

  if (
    !parseLocalStorage?.isLoggedIn &&
    !isPublicRoute &&
    window.location.pathname
  ) {
    localStorage.setItem(
      LocalStorage.NEXT_PAGE_IRELAND,
      window.location.pathname
    );
  }

  return (
    <Router>
      <Layout>
        <TopMenu
          isLoggedIn={parseLocalStorage?.isLoggedIn}
          loggedInInitials={loggedInInitials}
        />
        <Switch>
          <Route
            path={Auth.LOGIN}
            render={() => {
              return isLoggedIn() ? (
                <Redirect to={App.DASHBOARD} />
              ) : (
                <Authentification />
              );
            }}
          />

          <Route
            path={Auth.REGISTER}
            render={() => {
              return isLoggedIn() ? (
                <Redirect to={App.DASHBOARD} />
              ) : (
                <Register />
              );
            }}
          />

          <Route
            path={Auth.VALIDATE}
            render={() => {
              return isLoggedIn() ? (
                <Redirect to={App.DASHBOARD} />
              ) : (
                <Validate />
              );
            }}
          />

          <Route
            path={Auth.RESET_PASSWORD}
            render={() => {
              return isLoggedIn() ? (
                <Redirect to={App.DASHBOARD} />
              ) : (
                <ResetPassword />
              );
            }}
          />

          <Route
            path={Auth.RESET_PASSWORD_VALIDATE}
            render={() => {
              return isLoggedIn() ? (
                <Redirect to={App.DASHBOARD} />
              ) : (
                <ResetPasswordValidate />
              );
            }}
          />

          {!!parseLocalStorage?.isLoggedIn && (
            <ProtectedRoute
              setLoggedInInitials={setLoggedInInitials}
              path={App.DASHBOARD}
              component={PrivateRoutes}
            />
          )}

          <Route path="/404" component={PageNotFound} />

          <Redirect to={Auth.LOGIN} />
        </Switch>
      </Layout>
    </Router>
  );
};

export default PublicRoutes;

const Layout = styled.div`
  position: relative;
  overflow-x: hidden;
  overflow-y: hidden;
  width: 100%;
  min-height: 100vh;
`;
